import React, { createContext, useContext, useState, useEffect } from 'react';

const DataContext = createContext();

export const useDataContext = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [formData, setFormData] = useState(() => {
    // Initialize formData from localStorage or with default values
    const storedData = localStorage.getItem('formData');
    return storedData ? JSON.parse(storedData) : {
      pageMortgageInformation: {},
      pageNumOfRentalProperty: {},
    };
  });

  // Update localStorage whenever formData changes
  useEffect(() => {
    localStorage.setItem('formData', JSON.stringify(formData));
  }, [formData]);

  const updateMortgageInformation = (data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      pageMortgageInformation: data,
    }));
  };

  const updateNumOfRentalProperty = (data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      pageNumOfRentalProperty: data,
    }));
  };

  const contextValue = {
    formData,
    updateMortgageInformation,
    updateNumOfRentalProperty,
  };

  return (
    <DataContext.Provider value={contextValue}>
      {children}
    </DataContext.Provider>
  );
};
